import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum ScanPassportStep {
  Scan = 'Scan',
  Success = 'Success',
  Fail = 'Fail',
  Bypass = 'Bypass',
}

export const scanPassportFlow: CheckinWorkflow<ScanPassportStep> = {
  id: FlowId.ScanPassport,
  entry: ScanPassportStep.Scan,
  steps: {
    [ScanPassportStep.Scan]: {
      id: ScanPassportStep.Scan,
      page: PageKey.SCAN_PASSPORT,
      next: (variables) => ({
        nextStep: variables.isScanPassportSuccess
          ? ScanPassportStep.Success
          : ScanPassportStep.Fail,
      }),
    },
    [ScanPassportStep.Success]: {
      id: ScanPassportStep.Success,
      page: PageKey.SCAN_PASSPORT_SUCCESS,
      next: () => ({ complete: true }),
    },
    [ScanPassportStep.Fail]: {
      id: ScanPassportStep.Fail,
      page: PageKey.SCAN_PASSPORT_FAIL,
      next: () => ({ nextStep: ScanPassportStep.Scan }),
      back: () => ({ nextStep: ScanPassportStep.Scan }),
      bypass: () => ({ nextStep: ScanPassportStep.Bypass }),
    },
    [ScanPassportStep.Bypass]: {
      id: ScanPassportStep.Bypass,
      page: PageKey.BYPASS,
      next: () => ({ complete: true }),
      back: () => ({ nextStep: ScanPassportStep.Scan }),
    },
  },
};
